<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">메뉴관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">메뉴 조회</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                메뉴 조회 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 80px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">메뉴ID</th>
                  <td>{{ item.menuNo }}</td>
                </tr>
                <tr>
                  <th scope="row">메뉴순서</th>
                  <td>{{ item.menuOrdr }}</td>
                </tr>
                <tr>
                  <th scope="row">메뉴명</th>
                  <td>{{ item.menuNm }}</td>
                </tr>
                <tr>
                  <th scope="row">상위메뉴ID</th>
                  <td>{{ item.upperMenuId }}</td>
                </tr>
                <tr>
                  <th scope="row">파일명</th>
                  <td>{{ item.progrmFileNm }}</td>
                </tr>
                <tr>
                  <th scope="row">관련 이미지명</th>
                  <td>{{ item.relateImageNm }}</td>
                </tr>
                <tr>
                  <th scope="row">관련 이미지 경로</th>
                  <td>{{ item.relateImagePath }}</td>
                </tr>
                <tr>
                  <th scope="row">메뉴설명</th>
                  <td>
                    <pre>{{ item.menuDc }}</pre>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('menulist')">목록</button>
          <!-- <button class="btn gray">삭제</button>
                    <button class="btn blue">수정</button> -->
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg1 }}</p>
        <p>{{ msg2 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert>
  </main>
</template>

<script>
import Alert from '../../../components/Alert01.vue';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      msg1: '등록 된 메뉴를 삭제하시겠습니까?',
      msg2: '노출되는 해당 정보가 모두 삭제 됩니다.',
      msg3: '정보를 변경 하시겠습니까?',

      item: {},
    };
  },

  components: {
    Alert,
  },

  mounted() {
    this.item = this.$route.query.item;
  },

  methods: {
    CancleBtn() {
      this.showModalMsgSuccess = false;
    },

    CloseBtn() {
      this.showModalMsgSuccess = false;
    },
  },
};
</script>
